import ManageLayout from "../../components/ManageLayout";
import Tbl from "../../../input_types/Tbl/Tbl";

export default function Accounts(){
    return <ManageLayout>
            <div>
                <h1>manage users</h1>
                <Tbl
                    tblName={"wwAppUsers"}
                    listFlds={"name,icon,email,cart,wishList"}
                ></Tbl>
            </div>;        
        </ManageLayout>

}